export default __webpack_public_path__ + "static/media/info.6b4c9ae0.svg";